import {useSelector} from 'react-redux'
import {getSplitBookingDetails} from 'modules/sapiSearch/selectors'
import {getAllOffersWithSplitBookings} from 'modules/sapiSearch/utils'

import {TOP_OFFERS_COUNT} from './TopOffers/Desktop/TopOffersDesktopLayout'
import {useAccommodationTopOffers} from './useAccommodationTopOffers'

export const useGetNextTopProviders = ({hotelId}: {hotelId: string}) => {
  const {offerEntity} = useAccommodationTopOffers({
    hotelId
  })
  const splitBookingDetails = useSelector(state =>
    getSplitBookingDetails(state, hotelId)
  )

  const allOffersWithSplitBookings = getAllOffersWithSplitBookings(
    offerEntity,
    splitBookingDetails
  )

  const flatProviders = allOffersWithSplitBookings.map(
    offer => offer.intermediaryProvider
  )

  return [...flatProviders.slice(TOP_OFFERS_COUNT), ...flatProviders].slice(
    0,
    3
  )
}
